import React from "react"
import { formatDateBR, formatTimeBR } from "../../inc/Fx/formatDateTime"
import "./style.css"

export default function TabelaConsultas({ agendamentos = [], retornos = [], pacienteNome = "", pacienteCpf = "" }) {

    const formatarNomeConsulta = (nome) => {
        if (!nome) return "N/A";
        if (nome.includes("Consulta")) return nome.replace(/Consulta\s*/i, "Consulta\n");
        if (nome.includes("Exame")) return nome.replace(/Exame\s*/i, "Exame\n");
        return nome;
    };

    const abreviarMedico = (nome) => {
        if (!nome) return ''
        return nome.split(' ').slice(0, 2)
            .map(p => p.charAt(0) + p.slice(1).toLowerCase())
            .join(' ')
    }

    const buildWhatsappUrl = (retorno) => {
        const saudacao = pacienteNome ? `Olá! Me chamo *${pacienteNome}* e gostaria` : `Olá! Gostaria`
        const cpfInfo = pacienteCpf ? ` Meu CPF é *${pacienteCpf}*.` : ""
        const msg = `${saudacao} de agendar um retorno para a consulta de *${retorno.procedimento_nome}* com *${retorno.profissional_nome}* realizada em *${formatDateBR(retorno.data_hora)}* na unidade *${retorno.unidade_nome}*. Meu retorno é válido até *${formatDateBR(retorno.data_limite_retorno)}*.${cpfInfo}`
        return `https://wa.me/552126665800?text=${encodeURIComponent(msg)}`
    }

    return (
        <>
            {/* Consultas Agendadas */}
            {agendamentos.length > 0 && (
                <div className="consultas-agendadas-section">
                    <h3 className="titulo-consultas align-center">Seus Agendamentos</h3>

                    {/* DESKTOP / TABLET: tabela tradicional */}
                    <div className="table-container show-desktop">
                        <div className="table-wrapper">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th className="table-header align-center">Procedimento</th>
                                        <th className="table-header align-center">Data</th>
                                        <th className="table-header align-center">Horário</th>
                                        <th className="table-header align-center">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {agendamentos.map((consulta, index) => (
                                        <tr key={index} className="table-row">
                                            <td className="table-cell primary align-center">
                                                <div className="procedimento-nome">
                                                    {formatarNomeConsulta(consulta.procedimento_name).split('\n').map((linha, i) => (
                                                        <div key={i}>{linha}</div>
                                                    ))}
                                                </div>
                                            </td>
                                            <td className="table-cell primary align-center">
                                                {formatDateBR(consulta.data)}
                                            </td>
                                            <td className="table-cell primary align-center">
                                                {formatTimeBR(consulta.horario)}
                                            </td>
                                            <td className="table-cell align-center">
                                                <span className={`status ${consulta.status_id === 7 ? 'confirmado' : 'pendente'}`}>
                                                    {consulta.status_id === 7 ? 'Agendamento Confirmado' : 'Confirmação Pendente'}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* MOBILE: sem tabela horizontal... */}
                    <div className="cards-container show-mobile">
                        {agendamentos.map((consulta, index) => (
                            <article key={index} className="consulta-card" aria-label="Consulta agendada">
                                <div className="kv">
                                    <span className="kv-label">Procedimento</span>
                                    <span className="kv-value">
                                        <div className="procedimento-nome">
                                            {(consulta.procedimento_name)}
                                        </div>
                                    </span>
                                </div>
                                <div className="kv">
                                    <span className="kv-label">Data</span>
                                    <span className="kv-value">{formatDateBR(consulta.data)}</span>
                                </div>
                                <div className="kv">
                                    <span className="kv-label">Horário</span>
                                    <span className="kv-value">{formatTimeBR(consulta.horario)}</span>
                                </div>
                                <div className="kv">
                                    <span className="kv-label">Status</span>
                                    <span className="kv-value">
                                        <span className={`status ${consulta.status_id === 7 ? 'confirmado' : 'pendente'}`}>
                                            {consulta.status_id === 7 ? 'Agendamento Confirmado' : 'Confirmação Pendente'}
                                        </span>
                                    </span>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            )}

            {/* Retornos Disponíveis */}
            {retornos.length > 0 && (
                <div className="retornos-section">
                    <h3 className="titulo-consultas align-center">Retornos Disponíveis</h3>

                    {/* DESKTOP / TABLET */}
                    <div className="table-container show-desktop">
                        <div className="table-wrapper">
                            <table className="custom-table">
                                <thead>
                                    <tr>
                                        <th className="table-header align-center">Procedimento</th>
                                        <th className="table-header align-center">Médico</th>
                                        <th className="table-header align-center">Data / Validade</th>
                                        <th className="table-header align-center">Ação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {retornos.map((retorno) => (
                                        <tr key={retorno.agendamento_id} className="table-row">
                                            <td className="table-cell primary align-center">
                                                <div className="procedimento-nome">{retorno.procedimento_nome}</div>
                                            </td>
                                            <td className="table-cell align-center">{abreviarMedico(retorno.profissional_nome)}</td>
                                            <td className="table-cell align-center">
                                                {formatDateBR(retorno.data_hora)} – {formatDateBR(retorno.data_limite_retorno)}
                                            </td>
                                            <td className="table-cell align-center">
                                                <a
                                                    href={buildWhatsappUrl(retorno)}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn-agendar-retorno"
                                                >
                                                    Agendar retorno
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* MOBILE */}
                    <div className="cards-container show-mobile">
                        {retornos.map((retorno) => (
                            <article key={retorno.agendamento_id} className="consulta-card" aria-label="Retorno disponível">
                                <div className="kv">
                                    <span className="kv-label">Procedimento</span>
                                    <span className="kv-value">
                                        <div className="procedimento-nome">{retorno.procedimento_nome}</div>
                                    </span>
                                </div>
                                <div className="kv">
                                    <span className="kv-label">Médico</span>
                                    <span className="kv-value">{abreviarMedico(retorno.profissional_nome)}</span>
                                </div>
                                <div className="kv">
                                    <span className="kv-label">Realizado em</span>
                                    <span className="kv-value">{formatDateBR(retorno.data_hora)}</span>
                                </div>
                                <div className="kv">
                                    <span className="kv-label">Válido até</span>
                                    <span className="kv-value">{formatDateBR(retorno.data_limite_retorno)}</span>
                                </div>
                                <div className="kv">
                                    <span className="kv-label">Ação</span>
                                    <span className="kv-value">
                                        <a
                                            href={buildWhatsappUrl(retorno)}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn-agendar-retorno"
                                        >
                                            Agendar retorno
                                        </a>
                                    </span>
                                </div>
                            </article>
                        ))}
                    </div>
                </div>
            )}
        </>
    )
}
